export const getLeases = state => state.search.leases;
export const getSales = state => state.search.sales;
